import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import toastr from 'toastr';
import * as settingService from "../../services/setting";

export function* get({ payload }) {
  const { group } = payload;

  yield put({
    type: 'setting/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(settingService.fetchSetting, group);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'setting/SET_STATE',
      payload: {
        [group]: data.data
      },
    })
  }

  yield put({
    type: 'setting/SET_STATE',
    payload: {
      loadingDetails: false
    },
  })
}

export function* update({ payload }) {
  const { group, values } = payload;

  yield put({
    type: 'setting/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(settingService.update, group, values);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'setting/SET_STATE',
      payload: {
        [group]: data.data,
      }
    });

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'setting/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }

  yield put({
    type: 'setting/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* refreshErrors() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_SETTING, get),
    takeEvery(actions.UPDATE_SETTING, update),
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
  ])
}
